import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const initialState: PaymentManagementState = {
    showOpenPaymentsModal: false,
    openPaymentsData: null,
    posPaymentAlertReminderHasBeenSet: undefined,
    pendingPaymentCheckouts: {},
    outOfPendingStatusCheckouts: {},
};

const paymentManagementSlice = createSlice({
    name: "paymentManagement",
    initialState,
    reducers: {
        toggleOpenPaymentsModal: (state, action: PayloadAction<{ showModal?: boolean } | undefined>) => {
            const {
                showModal = !state.showOpenPaymentsModal,
            } = action.payload || {};

            state.showOpenPaymentsModal = showModal;
        },
        changeOpenPaymentsData: (state, action: PayloadAction<CashBoxOpenPaymentsItemData[] | null>) => {
            state.openPaymentsData = action.payload ?? null;
        },
        toggleShowingPosPaymentAlertReminder: (state, action: PayloadAction<{ setReminder?: boolean } | undefined>) => {
            const { setReminder } = action.payload || {};
            state.posPaymentAlertReminderHasBeenSet = setReminder;
        },
        addToPendingPaymentCheckouts: (state, action: PayloadAction<{
            table_id: number | null;
            order_type: ApiOrderType;
            order_id: number;
            checkout_id: number;
        }>) => {
            const { table_id, order_type, order_id, checkout_id } = action.payload || {};

            state.pendingPaymentCheckouts = {
                ...state.pendingPaymentCheckouts,
                [checkout_id]: {
                    order_id,
                    table_id,
                    order_type,
                },
            };
        },
        addToOutOfPendingStatusCheckouts: (state, action: PayloadAction<{
            table_id: number | null;
            order_type: ApiOrderType;
            order_id: number;
            checkout_id: number;
        }>) => {
            const { table_id, order_type, order_id, checkout_id } = action.payload || {};

            delete state.pendingPaymentCheckouts[checkout_id];

            state.outOfPendingStatusCheckouts = {
                ...state.outOfPendingStatusCheckouts,
                [checkout_id]: {
                    table_id,
                    order_id,
                    order_type,
                },
            };
        },
        removeFromOutOfPendingStatusCheckouts: (state, action: PayloadAction<{ checkout_id?: CashBoxId } | undefined>) => {
            const { checkout_id } = action.payload || {};

            if (checkout_id) {
                delete state.outOfPendingStatusCheckouts[checkout_id];
            }
        },
    },
});

export const {
    toggleOpenPaymentsModal,
    changeOpenPaymentsData,
    toggleShowingPosPaymentAlertReminder,
    addToPendingPaymentCheckouts,
    addToOutOfPendingStatusCheckouts,
    removeFromOutOfPendingStatusCheckouts,
} = paymentManagementSlice.actions;

export default paymentManagementSlice.reducer;
